import { loadableWithFallback } from '@vision/ui/utils';
import type { CardChartAtaProps } from './CardChartAta';

export const CardChartAta = loadableWithFallback<CardChartAtaProps>(() => import('./CardChartAta'));
